import { graphql } from 'gatsby';
import React from 'react';

import Block from '~/components/blocks/core/Block';

const BlockBlock = ({ innerBlocks }) => <Block blocks={innerBlocks} />;

export default BlockBlock;

export const fragment = graphql`
    fragment BlockBlockFragment on WpCoreBlock {
        name
        innerBlocks {
            ...BlockBlockListFragment
        }
    }
`;

export const exampleData = [
    {
        variant: 'Block Patterns',
        description:
            'Any block can be used to create a Pattern that can be used across pages. Patterns can be set to Sync so that editing the pattern will update it anywhere it is used.',
        props: {
            name: 'core/block',
            innerBlocks: []
        }
    }
];
